import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { LayoutDashboard, FileText, FolderOpen, LogOut, ExternalLink, Mail } from 'lucide-react';

const AdminLayout = ({ children }) => {
  const { user, logout } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate('/admin');
  };

  const navItems = [
    { path: '/admin/dashboard', label: 'Dashboard', icon: LayoutDashboard },
    { path: '/admin/articles', label: 'Articles', icon: FileText },
    { path: '/admin/categories', label: 'Categories', icon: FolderOpen },
    { path: '/admin/newsletter', label: 'Newsletter', icon: Mail },
  ];

  return (
    <div className="min-h-screen bg-[#F8F9FA] flex">
      {/* Sidebar */}
      <aside className="admin-sidebar w-64 flex-shrink-0 p-6 flex flex-col">
        <div className="mb-8">
          <h2 className="font-heading text-xl text-white mb-1">LHSC Admin</h2>
          <p className="text-sm text-white/50">{user?.email}</p>
        </div>

        <nav className="flex-1 space-y-1">
          {navItems.map((item) => (
            <Link
              key={item.path}
              to={item.path}
              className={`admin-nav-item ${location.pathname === item.path ? 'active' : ''}`}
              data-testid={`nav-${item.label.toLowerCase()}`}
            >
              <item.icon className="w-5 h-5" />
              <span className="font-label text-xs tracking-widest">{item.label.toUpperCase()}</span>
            </Link>
          ))}
        </nav>

        <div className="border-t border-white/10 pt-4 space-y-1">
          <a
            href="/en/blog"
            target="_blank"
            rel="noopener noreferrer"
            className="admin-nav-item"
          >
            <ExternalLink className="w-5 h-5" />
            <span className="font-label text-xs tracking-widest">VIEW BLOG</span>
          </a>
          <button
            onClick={handleLogout}
            className="admin-nav-item w-full text-left"
            data-testid="logout-btn"
          >
            <LogOut className="w-5 h-5" />
            <span className="font-label text-xs tracking-widest">LOGOUT</span>
          </button>
        </div>
      </aside>

      {/* Main Content */}
      <main className="flex-1 overflow-auto">
        {children}
      </main>
    </div>
  );
};

export default AdminLayout;
